import 'css-chunk:src/feature/check-print/CheckDetailPrintJobsTab.module.scss';export default {
  "root": "CheckDetailPrintJobsTab_root",
  "grid": "CheckDetailPrintJobsTab_grid",
  "gridHeader": "CheckDetailPrintJobsTab_gridHeader",
  "col1Header": "CheckDetailPrintJobsTab_col1Header",
  "col1": "CheckDetailPrintJobsTab_col1",
  "col3": "CheckDetailPrintJobsTab_col3",
  "col5": "CheckDetailPrintJobsTab_col5",
  "scrollGrid": "CheckDetailPrintJobsTab_scrollGrid",
  "isNoPrint": "CheckDetailPrintJobsTab_isNoPrint"
};